import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconChevronLargeTop: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1-IconChevronLargeTop"><Path fillRule="evenodd" clipRule="evenodd" d="M12.6987 10.4324C12.2614 10.2022 11.7388 10.2022 11.3015 10.4324L2.73297 14.9421C2.48861 15.0707 2.18625 14.9769 2.05764 14.7325C1.92903 14.4882 2.02286 14.1858 2.26723 14.0572L10.8357 9.54747C11.5646 9.16386 12.4356 9.16386 13.1645 9.54747L21.733 14.0572C21.9773 14.1858 22.0712 14.4882 21.9426 14.7325C21.8139 14.9769 21.5116 15.0707 21.2672 14.9421L12.6987 10.4324Z" fill="currentColor"/></CentralIconBase>;
});

export default IconChevronLargeTop;
